export default "__VITE_ASSET__B3ve47pA__"